import { createContext, useCallback, useContext, useMemo } from 'react'
import { useModal } from '../../context/ModalContext'
import { useBookmarks } from '../../hooks/useBookmarks'

const ItemBookmarkContext = createContext(null)

// Shares the library nav's bookmark action with surfaces that cite items
// (searchroom and global AI answers). One list for the page, so a filled tag
// stays in sync across open windows. Absent on pages that don't provide it.
export function ItemBookmarkProvider({ children }) {
  const { isBookmarked, getBookmark, reload } = useBookmarks()
  const { openModal } = useModal()

  const bookmarkItem = useCallback(
    (item) => {
      if (!item?._id) return
      const existing = getBookmark(item._id)
      if (existing) {
        openModal('edit-bookmark', { bookmark: existing, onSaved: reload })
      } else {
        openModal('create-bookmark', { item, onSaved: reload })
      }
    },
    [getBookmark, openModal, reload]
  )

  const value = useMemo(
    () => ({ isBookmarked, bookmarkItem }),
    [isBookmarked, bookmarkItem]
  )

  return <ItemBookmarkContext.Provider value={value}>{children}</ItemBookmarkContext.Provider>
}

export function useItemBookmark() {
  return useContext(ItemBookmarkContext)
}
